import {styled, TableRow} from "@mui/material";
import theme2 from "../lib/theme";

const TableHeaderRow = styled(TableRow)(({ theme }) => ({
    'th': {backgroundColor: "#eeeeee", fontWeight: 'bold'}
}));

export default TableHeaderRow;
